import { Type } from 'class-transformer';
import { IsArray, IsEnum, IsNumber, IsString, Length, ValidateIf, ValidateNested } from 'class-validator';

import { ItemTypeEnum } from '@onArte/shared/database/enums';
import { AttachmentModel } from '@onArte/shared/models/common/attachments';
import { ItemAttributeModel } from '@onArte/shared/models/common/items';
import { ManufacturerModel } from '@onArte/shared/models/website/items';

export class UpdateItemModel {
  @IsEnum(ItemTypeEnum)
  public type: ItemTypeEnum;

  @IsNumber()
  public categoryId: number;

  @IsString()
  @Length(3, 64)
  public name: string;

  @IsString()
  @Length(0, 2000)
  public description: string;

  @IsString()
  @Length(1, 32)
  public year: string;

  @IsString()
  @Length(32, 36)
  @ValidateIf((object: unknown, value: unknown) => value !== null)
  public locationId: string | null;

  @ValidateNested()
  @Type(() => ManufacturerModel)
  public manufacturer: ManufacturerModel;

  @IsArray()
  @Type(() => ItemAttributeModel)
  @ValidateNested({ each: true })
  public attributes: ItemAttributeModel[];
  
  @IsArray()
  @Type(() => AttachmentModel)
  @ValidateNested({ each: true })
  public attachments: AttachmentModel[];

  constructor(
    type: ItemTypeEnum,
    categoryId: number,
    name: string,
    year: string,
    manufacturer: ManufacturerModel,
    locationId: string | null,
    attributes: ItemAttributeModel[],
    attachments: AttachmentModel[],
    description: string,
  ) {
    this.type = type;
    this.categoryId = categoryId;
    this.name = name;
    this.year = year;
    this.manufacturer = manufacturer;
    this.locationId = locationId;
    this.attributes = attributes;
    this.attachments = attachments;
    this.description = description;
  }
}
